<template>
    <div align="center">
        <br><br>
        <a class="link" @click='regresar' >Regresar</a><br><br>

        <div v-if="inmuebles">
            <div v-for="inmueble in inmuebles">
                <img v-bind:src="imagen(inmueble.foto1)" 
                    width = "512" 
                    height = "512"
                    class="animate__animated animate__zoomIn"
                >
                <br><br>
                <img v-bind:src="imagen(inmueble.foto2)" 
                    width = "512" 
                    height = "512"
                    class="animate__animated animate__zoomIn"                    
                >
            </div>
        </div>
        <span v-else><button class="button is-primary is-loading">Loading</button></span>

        <a class="link" @click='regresar' >Regresar</a>

    </div>
</template>

<script>
    import axios from 'axios';

    export default {
          name: 'fotosInmu',
          mounted(){   
              this.getInmuebles();  
          },
          props: ['folioF'], 
          data () {
            return {
                inmuebles:[]

            }
          },
          methods:{
            getInmuebles(){
                axios.get('https://www.rentas-ventas.com/leeUnInmueble.php?inm48=' + this.folioF)
                     .then((respue) => {
                        this.inmuebles = respue.data;
                    })
            },
            imagen(cualImagen){
                return "https://www.rentas-ventas.com/fotosrentasventas/" + cualImagen;
            },
            regresar(){
                this.$emit('regresar'); 
                this.$router.push({ name: '/'});
            }
            
          }

    };

</script>

<style lang="scss">    

</style>


// WEBPACK FOOTER //
// src/Verfotos.vue